var React = require('react');

function IconStartmail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 2.12v-.982A1.14 1.14 0 0010.861 0H1.138A1.14 1.14 0 000 1.139v.955c.445.432 4.593 4.357 6.02 4.357 1.518 0 5.509-3.873 5.98-4.331z","fill":"#6573FF","key":0}),React.createElement("path",{"d":"M9.867 5.693C8.231 7.17 6.936 7.917 6.02 7.917 3.952 7.917.445 4.79 0 4.371v6.49C0 11.49.51 12 1.138 12h9.723A1.14 1.14 0 0012 10.861V3.533a28.631 28.631 0 01-2.133 2.16z","fill":"#202945","key":1})]);
}

IconStartmail.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = IconStartmail;

IconStartmail.default = IconStartmail;
